import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionComponent } from '../accordion/accordion.component';
import { SurveyFormComponent } from './survey-form/survey-form.component';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'ppl-survey',
  standalone: true,
  imports: [CommonModule, AccordionComponent, SurveyFormComponent],
  templateUrl: './survey.component.html',
  styleUrl: './survey.component.css'
})
export class SurveyComponent implements OnInit {

  constructor(private sharedService: SharedService) {}

  @Input() entry: any;
  @Input() recordId: any;
  surveyHistoryData: { srvySubmitDate: string; srvyId: number; srvyRespJson: string; srvyDesc?: string; srvyDate?: string }[] = [];

  ngOnInit(): void {
    this.getHistoryData();
  }

  getHistoryData() {
    const payload = {
      recordId: this.recordId,
      userType: this.entry?.toLowerCase() === 'participantenrollment' ? 'EMP'
      : this.entry?.toLowerCase() === 'providerenrollment' ? 'IR'
      : null
    };

    this.sharedService.getSurveyResponses(payload).subscribe((data) => {
      const response = data as { responsedata: { srvySubmitDate: string; srvyId: number; srvyRespJson: string; srvyDesc?: string; srvyDate?: string }[] };
      this.surveyHistoryData = response.responsedata ?? [];
    });
  }
}
